var _Object$assign = require("../core-js/object/assign");

function _extends() {
  module.exports = _extends = _Object$assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/helpers/extends.js
// module id = 9
// module chunks = 0